import { noop } from "lodash";
import React from "react";

type ProtectedLinkProps = {
  href?: string;
  className?: string;
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  actionGuard?: (action: () => void, fallback?: () => void) => void;
};

const ProtectedLink: React.FC<ProtectedLinkProps> = ({
  href,
  className,
  children,
  actionGuard,
  onClick,
}) => {
  const checkProtection = (
    e: React.MouseEvent<HTMLDivElement> | React.KeyboardEvent<HTMLDivElement>
  ) => {
    actionGuard?.(noop, () => {
      e.preventDefault();
      e.stopPropagation();
    });
  };

  return (
    <a href={href} className={className} onClick={onClick}>
      <div
        role="link"
        tabIndex={0}
        onClick={checkProtection}
        onKeyDown={checkProtection}
      >
        {children}
      </div>
    </a>
  );
};

export default ProtectedLink;
